import React from 'react'
import { LabelValueType } from '../../../types/dataTypes'
import BasicModal from '../../../common/components/Modal'
import Label from '../../../common/components/Label'
import TextBox from '../../../common/components/Textbox'
import { COLOR_MAP } from '../../../constants/ColorNames'
import { Box, BoxProps, Button, ClickAwayListener, Modal } from '@mui/material'
import styled from '@emotion/styled'

type CampaignPlaceholderInputListPropsType = {
  placeholderValues: LabelValueType[],
  isOpen: boolean,
  onClose: (placeholderDetails: LabelValueType[], startCampaign: boolean) => void
}

type PlaceholderContentType = {
  onValueUpdate: (label: string, value: string) => void;
  label: string;
  value: string;
  showError?: boolean;
  errorMessage?: string
}

const ModalContainer = styled(Box)(() => ({
  fontFamily: 'Noto Sans',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '36rem',
  minHeight: '20rem',
  borderRadius: '1.6rem',
  backgroundColor: COLOR_MAP.WHITE,
}));

const Heading = styled.span`
    padding: 1.6rem;
    border-bottom: 0.1rem solid ${COLOR_MAP.DISABLED};
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: ${COLOR_MAP.BLACK};
    display: flex;
`

const Content = styled.div`
    padding: 1.6rem;
    color: ${COLOR_MAP.GREY_10};
    font-weight: 400;
    font-size: 1.4rem;
    line-height:2rem;
    display: flex;
    flex-direction: column;
    max-height: 280px;
    overflow-y: scroll;

    ::-webkit-scrollbar {
    width: 4px;
  };

  ::-webkit-scrollbar-thumb {
     border-radius: 8px;
    background-color: ${COLOR_MAP.GREY_1};
}
}
`;

const ButtonContainer = styled.div`
  text-align: center;
    padding: 12px 16px;
    background-color: ${COLOR_MAP.WHITE};
     border-radius: 0 0 16px 16px;
    box-shadow: 0px -2px 2px -2px #00000026, 0px -4px 8px -2px #00000014;
    & .MuiButtonBase-root {
    text-transform: capitalize;
  }
`


const PlaceholderContent = React.memo((props: PlaceholderContentType) => {
  const { onValueUpdate, label, value, showError, errorMessage } = props;
  const [inputValue, setInputValue] = React.useState<string>(value);

  const onValueChange = (label: string, value: string) => {
    setInputValue(value);
    onValueUpdate(label, value);
  }
  return (
    <>
      <Label
        label={label}
        labelFor="campaignName"
        required
        colorType="light"
      />
      <TextBox
        placeholder={`Enter text`}
        sx={{
          marginTop: '4px',
          color: COLOR_MAP.GREY_0,
          marginBottom: '16px'
        }}
        textValue={inputValue}
        handleChange={(e) => onValueChange(label, e.target.value)}
        id='compaignAttributte'
        showError={showError}
        errorMessage={errorMessage}
      // onKeyDown={handelEnterKey}

      />
    </>
  )
})

const CampaignPlaceholderInputList = (props: CampaignPlaceholderInputListPropsType) => {
  const { placeholderValues, isOpen, onClose } = props;

  const [placeholderList, setPlaceholderList] = React.useState<LabelValueType[]>(JSON.parse(JSON.stringify(placeholderValues)));
  const [emptyPlaceholders, setEmptyPlaceholders] = React.useState<string[]>([]);



  const onValueUpdate = (label: string, value: string) => {
    let updatedList = [...placeholderList];
    updatedList.forEach((item) => {
      if (item.label.includes(label)) {
        item.value = value;
      }
    })
    setPlaceholderList(updatedList);
  }

  const handleOnPlaceholderClose = React.useCallback((isSubmit: boolean) => {
    let emptyLabels = placeholderList.filter(item => !item.value).map(item => item.label);
    if (isSubmit) {
      setEmptyPlaceholders(emptyLabels);
      if (emptyLabels.length) return;
      else {
        onClose(placeholderList, true);
      }
    }
    else {
      onClose(placeholderList, false)
    }

  }, [onClose, placeholderList])

  return (
    <Modal
      open={isOpen}
      onClose={() => handleOnPlaceholderClose(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalContainer>
        <Heading>
          Add the missing placeholder values
        </Heading>
        <Content>
          {
            placeholderList.map((placeholder) => {
              const label = placeholder.label.split('@')[1];
              const showError = emptyPlaceholders.includes(placeholder.label);
              const errorMessage = showError ? `Please enter ${label} value` : '';
              return (
                <PlaceholderContent label={label} value={placeholder.value} onValueUpdate={onValueUpdate} showError={showError} errorMessage={errorMessage} />
              )
            })
          }

        </Content>
        <ButtonContainer>
          <Button sx={{ padding: '0.8rem 1.2rem' }} onClick={() => handleOnPlaceholderClose(true)} variant={'contained'}>Update Placeholders & Send Campaign</Button>
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  )
}

export default CampaignPlaceholderInputList